module.exports = __webpack_public_path__ + "media/images/lb/859-38c0c85ef4757cc1e6e90404720d97dc.svg";